import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import { BaseResourceService } from '@kailona/core';
import mapFromFHIR from '../mappers/mapFromFHIR';
import { mapToFHIRBloodPressure, mapToFHIRHeartRate, mapToFHIROxygenSaturation, mapToFHIRBodyTemperature, mapToFHIRVitalsPanel } from '../mappers/mapToFHIR';

var VitalsService = /*#__PURE__*/function (_BaseResourceService) {
  _inherits(VitalsService, _BaseResourceService);

  var _super = _createSuper(VitalsService);

  function VitalsService() {
    _classCallCheck(this, VitalsService);

    return _super.call(this, 'Observation');
  }

  _createClass(VitalsService, [{
    key: "fetchData",
    value: function () {
      var _fetchData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(VitalsService.prototype), "fetchData", this).call(this, [{
                  patient: "Patient/".concat(this.patientId),
                  category: 'http://hl7.org/fhir/ValueSet/observation-category|vital-signs'
                }].concat(_toConsumableArray(params)));

              case 2:
                data = _context.sent;
                return _context.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: "fetchNextData",
    value: function () {
      var _fetchNextData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var data;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _get(_getPrototypeOf(VitalsService.prototype), "fetchNextData", this).call(this);

              case 2:
                data = _context2.sent;
                return _context2.abrupt("return", mapFromFHIR(data));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchNextData() {
        return _fetchNextData.apply(this, arguments);
      }

      return fetchNextData;
    }()
  }, {
    key: "upsertData",
    value: function () {
      var _upsertData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var idMap, bloodPressureObservationToUpsert, heartRateObservationToUpsert, oxygenSaturationObservationToUpsert, bodyTemperatureObservationToUpsert, observationIds, vitalsPanelObservationToUpsert;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                idMap = {}; // Blood Pressure

                bloodPressureObservationToUpsert = mapToFHIRBloodPressure(data);
                _context3.next = 4;
                return _get(_getPrototypeOf(VitalsService.prototype), "upsertData", this).call(this, bloodPressureObservationToUpsert);

              case 4:
                idMap.bloodPressure = _context3.sent;
                // Heart Rate
                heartRateObservationToUpsert = mapToFHIRHeartRate(data);
                _context3.next = 8;
                return _get(_getPrototypeOf(VitalsService.prototype), "upsertData", this).call(this, heartRateObservationToUpsert);

              case 8:
                idMap.heartRate = _context3.sent;
                // Oxygen Saturation
                oxygenSaturationObservationToUpsert = mapToFHIROxygenSaturation(data);
                _context3.next = 12;
                return _get(_getPrototypeOf(VitalsService.prototype), "upsertData", this).call(this, oxygenSaturationObservationToUpsert);

              case 12:
                idMap.oxygenSaturation = _context3.sent;
                // Body Temperature
                bodyTemperatureObservationToUpsert = mapToFHIRBodyTemperature(data);
                _context3.next = 16;
                return _get(_getPrototypeOf(VitalsService.prototype), "upsertData", this).call(this, bodyTemperatureObservationToUpsert);

              case 16:
                idMap.bodyTemperature = _context3.sent;
                // Vitals Panel
                observationIds = Object.values(idMap).filter(function (v) {
                  return !!v;
                });
                vitalsPanelObservationToUpsert = mapToFHIRVitalsPanel(data, observationIds);
                _context3.next = 21;
                return _get(_getPrototypeOf(VitalsService.prototype), "upsertData", this).call(this, vitalsPanelObservationToUpsert);

              case 21:
                idMap.panel = _context3.sent;
                return _context3.abrupt("return", idMap);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function upsertData(_x2) {
        return _upsertData.apply(this, arguments);
      }

      return upsertData;
    }()
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return VitalsService;
}(BaseResourceService);

export { VitalsService as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(VitalsService, "VitalsService", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/services/VitalsService.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();